import api from './api'

export interface Class {
  id: string
  name: string
  level?: string
  studentCount?: number
  createdAt: string
  updatedAt: string
}

const classService = {
  async getAll(): Promise<Class[]> {
    const response = await api.get('/api/classes')
    // Le backend retourne soit { classes: [...] } soit directement [...]
    if (response.classes && Array.isArray(response.classes)) {
      return response.classes
    }
    if (Array.isArray(response)) {
      return response
    }
    console.error('Format de réponse inattendu pour getAll():', response)
    return []
  },

  async getById(id: string): Promise<Class> {
    const response = await api.get(`/api/classes/${id}`)
    return response.class || response
  },

  async create(data: Partial<Class>): Promise<Class> {
    const response = await api.post('/api/classes', data)
    return response.class || response
  },

  async update(id: string, data: Partial<Class>): Promise<Class> {
    const response = await api.put(`/api/classes/${id}`, data)
    return response.class || response
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/classes/${id}`)
  }
}

export default classService
